import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  createExpenseCategoryApi,
  updateExpenseCategoryApi,
} from "../../../services/ExpenseService";
const AddCategoryModal = ({ visible, onClose, onAfterSubmit, data = null }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    description: "",
  });
  const [error, setError] = useState({});

  useEffect(() => {
    if (visible) handleReset();
  }, [visible]);

  const handleReset = () => {
    if (data) {
      setForm({
        name: data?.name || "",
        description: data?.description || "",
      });
    } else {
      setForm({
        name: "",
        description: "",
      });
    }
    setError({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({ ...prev, [name]: value }));

    if (value && error?.[name]) {
      setError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = () => {
    let error = {};

    if (!form.name?.trim()) {
      error.name = "Name is required";
    }

    setError(error);

    if (Object.keys(error).length === 0) {
      if (data) {
        updateCategory();
      } else {
        addCategory();
      }
    }
  };

  const updateCategory = () => {
    setLoading(true);
    updateExpenseCategoryApi(data?.id || "", form)
      .then(() => {
        toast.success("Category update successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };
  const addCategory = () => {
    setLoading(true);
    createExpenseCategoryApi(form)
      .then(() => {
        toast.success("Category Added successfully");
        handleReset();
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {data ? "Update Expense Category" : "Add Expense Category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          <div className="mb-2">
            <label className="form-label text-dark">Category Name</label>
            <input
              type="text"
              name="name"
              className={`form-control ${error?.name ? "is-invalid" : ""}`}
              value={form.name}
              placeholder="e.g. Polish"
              onChange={handleInputChange}
            />
            {error?.name && <small className="text-danger">{error.name}</small>}
          </div>
          <div className="mb-2">
            <label className="form-label text-dark">Description</label>
            <textarea
              name="description"
              className="form-control"
              value={form.description}
              onChange={handleInputChange}
              rows={3}
              placeholder="Enter description"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-outline-dark"
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />}
            {data ? "Update" : "Submit"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCategoryModal;
